import axios from 'axios'

const state = {
  countries: [],
  timezones: [],
  timezone: {},
  address: [],
  currentAddress: {
    lat: undefined,
    lng: undefined,
  },
}

const mutations = {
  add_countries (state, countries) {
    state.countries = countries
  },
  timezones_data (state, timezones) {
    state.timezones = timezones
  },
  timezone_data (state, timezone) {
    state.timezone = timezone
  },
  address_data (state, address) {
    state.address = address
  },
  set_current_address (state, address) {
    state.currentAddress.lat = address.lat
    state.currentAddress.lng = address.lng
  },
  reset_current_address (state) {
    state.currentAddress.lat = undefined
    state.currentAddress.lng = undefined
  },
}

const actions = {
  countries ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/country',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          commit('add_countries', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  timezones ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/timezones',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          commit('timezones_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  timezonesByCountry ({ commit }, countryId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/timezones/country?id=' + countryId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          commit('timezones_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  timezoneById ({ commit }, timezoneId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/timezone?id=' + timezoneId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          commit('timezone_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAddress ({ commit }, address) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'https://nominatim.openstreetmap.org/search?format=json&limit=3&q=' + address,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          commit('address_data', resp.data)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
